import React, { Component } from 'react';

import ArrowUpIcon from 'icons/ArrowUpIcon';
import ArrowDownIcon from 'icons/ArrowDownIcon';

class SortableHeaderCell extends Component {
  render() {
    const { column, style } = this.props;

    return (
      <div style={style} className="table-cell-inner">
        {column.label}
        {column.sortable && column.sortDirection === 'asc' && <ArrowUpIcon solid={column.sortOrder === 1} />}
        {column.sortable && column.sortDirection === 'desc' && <ArrowDownIcon solid={column.sortOrder === 1} />}
      </div>
    );
  }
}

export default SortableHeaderCell;
